import axios from "axios";
import { FETCH_PSATYPICAL, HANDLE_ERRORS, LOADING_MODE } from "./types";
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const getPSAtypical = () => async dispatch => {
  try {
    dispatch({ type: LOADING_MODE, payload: true, meta: { type: 'atypicalPs' } });
    const response = await axios.get(
      `${BASE_URL}/api/file/peak_shaving_atypical`,
      authorizeRequest()
    );

    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });
    await dispatch({
      type: FETCH_PSATYPICAL,
      payload: response
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'atypicalPs' } });
  } catch (error) {
    console.error("error fetching peak shaving atypical", error);
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: error.message, open: true }
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'atypicalPs' } });
  }
};



// WEBPACK FOOTER //
// ./src/actions/getPSAtypical.js